import  { useState } from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle, useTheme,TextField, Button, Typography } from '@mui/material';

const PreviewPurchaseIndentEmail = ({ open, onClose, onSend, poData }) => {
  const [email, setEmail] = useState('');
  const [cc, setCc] = useState('');

  const handleSend = () => {
    onSend(email, cc);
    onClose();
  };

    const theme = useTheme();
    // const colors = tokens(theme.palette.mode);

  return (
    <Dialog  open={open} onClose={onClose} fullWidth>
      <DialogTitle style={{ margin: "dense", backgroundColor: theme.palette.background.default }}>Preview and Send Email</DialogTitle>
      <DialogContent style={{ margin: "dense", backgroundColor: theme.palette.background.default }}>
        <Typography variant="h6">Purchase Indent Details</Typography>
        <div>
          <Typography variant="subtitle1">Purchase Order Number: {poData.purchase_indent_number}</Typography>
          <Typography variant="subtitle1">Reference Number: {poData.referenceNumber}</Typography>
          <Typography variant="subtitle1">Date: {poData.purchase_date}</Typography>
          <Typography variant="subtitle1">Expected Delivery Date: {poData.expectedDeliveryDate}</Typography>
          <Typography variant="subtitle1">Payment Terms: {poData.paymentTerms}</Typography>
          <Typography variant="subtitle1">Shipment Preference: {poData.shipmentPreference}</Typography>
          <Typography variant="subtitle1">Customer Notes: {poData.customerNotes}</Typography>
          <Typography variant="subtitle1">Subtotal: {poData.subtotal}</Typography>
          <Typography variant="subtitle1">Total Quantity: {poData.totalQuantity}</Typography>
          <Typography variant="subtitle1">Discount: {poData.discount}</Typography>
          <Typography variant="subtitle1">Adjustment: {poData.adjustment}</Typography>
          <Typography variant="subtitle1">TCS: {poData.tcs}</Typography>
          <Typography variant="subtitle1">Total: {poData.total}</Typography>
        </div>
        <TextField
          label="To"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          fullWidth
          margin="normal"
          size='small'
        />
        <TextField
          label="CC"
          value={cc}
          onChange={(e) => setCc(e.target.value)}
          fullWidth
          margin="normal"
          size='small'
        />
      </DialogContent>
      <DialogActions style={{ margin: "dense", backgroundColor: theme.palette.background.default }}>
        <Button variant='contained' onClick={onClose}>Cancel</Button>
        <Button variant='contained' onClick={handleSend} color="secondary">Send</Button>
      </DialogActions>
    </Dialog>
  );
};

export default PreviewPurchaseIndentEmail;
